// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-cad-produtos {
  display: flex;
  justify-content: space-between;
}

.ContainerCatProdutos {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 10px;
}

.containerPagination {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.containerPagination button {
  border: none;
  outline: none;
  background: inherit;
  margin: 0 5px;
}

.ItemTree {
  width: 100%;
  position: relative;
  padding: 5px 0;
}
.ItemTree section {
  background-color: #f5f8fa;
  border-left: 4px solid #3680bf;
  display: flex;
  width: auto;
  font-weight: 700;
  font-size: 14px;
  text-transform: initial;
  padding: 10px 0;
}
.ItemTree section button {
  margin-left: 8px;
  background-color: transparent;
  border: none;
}

.numberPagination {
  font-size: 12px;
  color: #757575;
  margin-right: 30px;
}

.sectionChild {
  background-color: #f5f8fa;
  border-left: none !important;
  position: absolute;
  padding-left: 500px !important;
}

.divBackgroundColor {
  background-color: #f5f8fa !important;
}

.centered-div {
  display: flex;
  align-items: right;
  justify-content: right;
  height: 100vh;
}

.categoryBackGroup {
  background-color: #f5f8fa;
}

.subCategoryBackGroup {
  background-color: #ccd7df;
}`, "",{"version":3,"sources":["webpack://./src/Components/Cadastro/Categorias/ListaCategorias/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;AACF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;AAAF;AAEE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;AAAJ;;AAIA;EACE,WAAA;EAEA,kBAAA;EACA,cAAA;AAFF;AAIE;EACE,yBAAA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;EAEA,gBAAA;EACA,eAAA;EAEA,uBAAA;EACA,eAAA;AAJJ;AAMI;EACE,gBAAA;EACA,6BAAA;EACA,YAAA;AAJN;;AASA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AANF;;AASA;EACE,yBAAA;EACA,4BAAA;EACA,kBAAA;EACA,8BAAA;AANF;;AASA;EACE,oCAAA;AANF;;AAQA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;AALF;;AAUA;EACE,yBAAA;AAPF;;AASA;EACE,yBAAA;AANF","sourcesContent":[".header-cad-produtos {\n  display: flex;\n  justify-content: space-between;\n  // margin-bottom: 5px;\n}\n\n.ContainerCatProdutos {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding-bottom: 10px;\n}\n\n.containerPagination {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n\n  button {\n    border: none;\n    outline: none;\n    background: inherit;\n    margin: 0 5px;\n  }\n}\n\n.ItemTree {\n  width: 100%;\n  // padding-left: 10px;\n  position: relative;\n  padding: 5px 0;\n\n  section {\n    background-color: #f5f8fa;\n    border-left: 4px solid #3680bf;\n    display: flex;\n    width: auto;\n\n    font-weight: 700;\n    font-size: 14px;\n\n    text-transform: initial;\n    padding: 10px 0;\n\n    button {\n      margin-left: 8px;\n      background-color: transparent;\n      border: none;\n    }\n  }\n}\n\n.numberPagination {\n  font-size: 12px;\n  color: #757575;\n  margin-right: 30px;\n}\n\n.sectionChild {\n  background-color: #f5f8fa;\n  border-left: none !important;\n  position: absolute;\n  padding-left: 500px !important;\n}\n\n.divBackgroundColor {\n  background-color: #f5f8fa !important;\n}\n.centered-div {\n  display: flex;\n  align-items: right;\n  justify-content: right;\n  height: 100vh;\n}\n// #btnFechar {\n//   position: relative;\n// }\n.categoryBackGroup {\n  background-color: #f5f8fa;\n}\n.subCategoryBackGroup {\n  background-color: #ccd7df;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
